import React, { useState } from 'react';

import { FaEye, FaEyeSlash } from 'react-icons/fa';
import CategoryTagsInput from '../CategoryTagsInput/CategoryTagsInput';

import './FormField.css';

const FormField = React.forwardRef(
  (
    {
      type,
      name,
      placeholder,
      label,
      value,
      onChange,
      options = [],
      noSelectOptionMsg,
      suggestions = [],
      autoComplete = 'off',
      readOnly = false,
      required = false,
      className = '',
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const hasText =
      (value !== null) & (value !== undefined) && String(value).length > 0;

    const inputType =
      type === 'password' ? (showPassword ? 'text' : 'password') : type;

    const classNames = [
      `form-field-${type}-input`,
      hasText ? 'input-label-float' : '',
      className,
    ].join(' ');

    const selectClassNames = [
      `form-field-select-input`,
      'input-label-float',
      className,
    ].join(' ');

    return (
      <>
        {type === 'text' && (
          <div className='input-wrapper'>
            <input
              type='text'
              name={name}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'textarea' && (
          <div
            className={`input-wrapper ${
              type === 'textarea' ? 'form-field-is-textarea' : ''
            }`}
          >
            <textarea
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              ref={ref}
              readOnly={readOnly}
              required={required}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'number' && (
          <div className='input-wrapper'>
            <input
              type='number'
              name={name}
              min='0'
              step='1'
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'currency' && (
          <div className='input-wrapper'>
            <input
              type='number'
              name={name}
              min='0'
              step='0.01'
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'url' && (
          <div className='input-wrapper'>
            <input
              type='url'
              pattern='https?://.+'
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'email' && (
          <div className='input-wrapper'>
            <input
              type='email'
              name={name}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'password' && (
          <div className='form-field-password-container'>
            <input
              type={inputType}
              name={name}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label
              className={`floating-label ${hasText ? 'input-label-float' : ''}`}
            >
              {label}
            </label>
            <button
              type='button'
              onClick={() => setShowPassword(!showPassword)}
              className='form-field-eye-button'
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        )}

        {type === 'checkbox' && (
          <div className='form-field-checkbox-label'>
            <input
              type='checkbox'
              name={name}
              min='0'
              step='0.01'
              value={value}
              checked={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
            <label>{label}</label>
          </div>
        )}

        {type === 'date' && (
          <div className='form-field-date-label'>
            <label>{`${label}:`}</label>
            <input
              type='date'
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={classNames}
            />
          </div>
        )}

        {type === 'select' && (
          <div className='input-wrapper'>
            <label
              className={`floating-label input-label-float`}
            >{`${label}:`}</label>
            <select
              name={name}
              value={value}
              onChange={onChange}
              readOnly={readOnly}
              required={required}
              autoComplete={autoComplete}
              ref={ref}
              className={selectClassNames}
            >
              <option value=''>{`-- ${
                noSelectOptionMsg || 'Select an option'
              } --`}</option>
              {options.map((opt, i) => (
                <option key={i} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {type === 'categories' && (
          <div className='input-wrapper'>
            <label className='form-field-categories-label'>{label}</label>
            <CategoryTagsInput
              value={value}
              onChange={onChange}
              suggestions={suggestions}
            />
          </div>
        )}
      </>
    );
  },
);

export default FormField;
